// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BanCircleOutlinedSvg from "@fishx/icons-svg/es/asn/BanCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var BanCircleOutlined = function BanCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BanCircleOutlinedSvg
  }));
};

BanCircleOutlined.displayName = 'BanCircleOutlined';
export default React.forwardRef(BanCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BanCircleOutlined.js
// module id = 2041
// module chunks = 0